import { AxiosResponse } from 'axios'
import { HttpClient, serializeJSONApiData } from '@opallabs/api'

export type Tab = 'Approval' | 'Task'

export type SubTab = 'Completed' | 'Overdue' | 'Pending' | 'Upcoming'

type DomainString = `Moments.PersonalPanel.${Tab}.${SubTab}`

interface CreateCheckpointArg {
  last_viewed_at: string
  subTab: SubTab
  tab: Tab
}

interface PostCheckpointAttributes {
  domain: DomainString
  last_viewed_at: string
}

type CreateCheckpoint = (arg: CreateCheckpointArg) => Promise<AxiosResponse>

export const createCheckpoint: CreateCheckpoint = async ({
  tab,
  subTab,
  last_viewed_at,
}) => {
  const params: PostCheckpointAttributes = {
    domain: `Moments.PersonalPanel.${tab}.${subTab}`,
    last_viewed_at,
  }
  const serializedParams = serializeJSONApiData<PostCheckpointAttributes>(
    'user_domain_view',
    params,
    true
  )
  try {
    return await HttpClient().post(
      `${window.location.origin}/user_domain_views/v2/user_domain_views`,
      {
        ...serializedParams,
      }
    )
  } catch (e) {
    console.error(e)
    return Promise.reject(e)
  }
}

interface PostOldCheckPointAttributes {
  checkpointable_id: string
  checkpointable_type: string
  section: string
}

interface PostOldCheckpointParams {
  data: {
    attributes: PostOldCheckPointAttributes
    type: string
  }
}

const postOldCheckpoint = async (
  params: PostOldCheckpointParams
): Promise<AxiosResponse> => {
  try {
    return await HttpClient().post(
      `${window.location.origin}/api/v1/checkpoints`,
      { ...params }
    )
  } catch (e) {
    console.error(e)
    return Promise.reject(e)
  }
}

export type OldCheckpointTab = Tab | 'Download' | 'Notification'

interface CreateOldCheckpointArg {
  id: string
  subTab?: SubTab
  tab: OldCheckpointTab
}

type CreateOldCheckpoint = (
  arg: CreateOldCheckpointArg
) => Promise<AxiosResponse>

export const createOldCheckpoint: CreateOldCheckpoint = ({
  tab,
  subTab,
  id,
}) => {
  const checkpointableParams = subTab
    ? {
        ct: 'Moments::PhaseItem',
        s: `Moments::${tab}::${subTab}`,
      }
    : {
        ct: 'Notification',
        s: `${tab}`,
      }

  const checkpointData = {
    checkpointable_id: id,
    checkpointable_type: checkpointableParams.ct,
    section: checkpointableParams.s,
  }

  const params = serializeJSONApiData<PostOldCheckPointAttributes>(
    'checkpoints',
    checkpointData,
    true
  )

  return postOldCheckpoint(params)
}
